module.exports = __webpack_public_path__ + "img/img_banner_index_01.d3e4f04b.jpg";